import React from "react";
import { Flex, Tag, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import {
  amlStatusField,
  amlSubLabelDefaultTag,
  amlSubLabelWarningTag,
} from "../styles_vanilla.css";
import { FieldLabel } from "./FieldLabel";
import { RefreshStatusData } from "./types";

export const RefreshStatus = ({
  label,
  refreshStatusData,
}: {
  label: string;
  refreshStatusData?: RefreshStatusData;
}) => (
  <div className={amlStatusField}>
    <FieldLabel label={label} />
    <Flex alignItems="center" gap={4}>
      <Icon
        type={refreshStatusData?.hasIssue ? "exclamation-triangle" : "circle-check"}
        variant="outline"
        color={refreshStatusData?.hasIssue ? Colors.Warning600 : Colors.Success600}
      />
      <Text variant="strong-lg">
        {refreshStatusData?.hasIssue ? "Issue detected" : "No issues"}
      </Text>
    </Flex>
    {refreshStatusData?.expiryInfo && (
      <Tag
        variant={refreshStatusData?.expiryInfo.variant}
        className={
          refreshStatusData?.expiryInfo.variant === "warning"
            ? amlSubLabelWarningTag
            : amlSubLabelDefaultTag
        }
      >
        <Icon type="clock" size="small" />
        {refreshStatusData?.expiryInfo?.value}
      </Tag>
    )}
  </div>
);
